import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import { selectShowEditTrackModal, selectTracks, selectEditingTrack } from "../redux/selectors";
import { closeEditTrackModal, editTrack } from "../redux/actions";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
        overflow: "visible"
    };
}

const styles = theme => ({
    paper: {
        position: "absolute",
        width: theme.spacing.unit * 55,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        overflow: "visible"
    },

    margin: {
        margin: theme.spacing.unit
    }
});

class EditTrackModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = { name: "" };
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.editingTrack !== prevProps.editingTrack &&
            this.props.editingTrack !== false
        ) {
            let name = "";
            if (this.props.editingTrack.childTrack === false) {
                name = this.props.tracks[this.props.editingTrack.parentTrack].name;
            } else {
                name = this.props.tracks[this.props.editingTrack.parentTrack].children[
                    this.props.editingTrack.childTrack
                ].name;
            }

            this.setState({
                name
            });
        }
    }

    handleClose = () => {
        this.props.closeEditTrackModal();
    };

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.show}
                    onClose={this.handleClose}
                >
                    <Card style={getModalStyle()} className={classes.paper}>
                        <CardHeader title={"Edit Track"} />

                        <CardContent>
                            <FormControl className={classes.margin}>
                                <InputLabel htmlFor="input-with-icon-adornment">Name</InputLabel>
                                <Input
                                    id="input-with-icon-adornment"
                                    value={this.state.name}
                                    onChange={e => {
                                        this.setState({
                                            ...this.state,
                                            name: e.target.value
                                        });
                                    }}
                                />
                            </FormControl>
                        </CardContent>
                        <CardActions className={classes.actions} disableActionSpacing>
                            <Button
                                href="#text-buttons"
                                className={classes.button}
                                onClick={e => {
                                    this.props.closeEditTrackModal();
                                    this.props.editTrack(
                                        this.state.name,
                                        this.props.editingTrack.parentTrack,
                                        this.props.editingTrack.childTrack,
                                        this.props.tracks
                                    );
                                }}
                            >
                                Edit
                            </Button>
                        </CardActions>
                    </Card>
                </Modal>
            </div>
        );
    }
}

export default withStyles(styles)(
    connect(
        store => {
            return {
                show: selectShowEditTrackModal(store),
                editingTrack: selectEditingTrack(store),
                tracks: selectTracks(store)
            };
        },
        { closeEditTrackModal, editTrack }
    )(EditTrackModal)
);
